/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormTextareaField, {
  FormTextareaFieldProps
} from '../../../../client/js/components/form/fields/FormTextareaField'

function NoteField (props: FormTextareaFieldProps) {
  const { name = 'note', ...others } = props
  const intl = useIntl()
  return (
    <FormTextareaField
      label={intl.formatMessage({
        id: 'note',
        defaultMessage: 'Note'
      })}
      name={name}
      rows={5}
      {...others}
    />
  )
}

export default NoteField
